import React from 'react'
import {
  Card,
  CardContent,
  CircularProgress,
  makeStyles,
} from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import policyDocumentPic from 'src/assets/PolicyTile_Images/policy.svg'
import healthCardImage from 'src/assets/images/healthCardImage.svg'
import policyDocumentDownloadPic from 'src/assets/PolicyTile_Images/Vector5.svg'
import documentDownload from 'src/utils/commonMethods/documentDownload'
import { useQuery } from '@apollo/client'
import { GET_HEALTHCARD_DETAILS } from 'src/services/individualService'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { Tooltip, Zoom } from '@mui/material'
import { GROUP_HEALTH_LIST } from 'src/utils/constants/RiskReports'
import {
  HEALTH_INSURANCE_LIST,
  HEALTH_STATS_INSURANCE_LIST,
} from 'src/utils/constants/common'
import {
  PLEASE_GET_IN_TOUCH_WITH_HR,
  YET_TO_BE_UPLOAD,
} from 'src/utils/constants/Individual'

const AllDocuments = ({
  data,
  healthCards,
  activePolicyInsuranceType,
  isCEO,
}) => {
  const classes = useStyles()

  const {
    loading: healthCardDetailsLoading,
    error: healthCardDetailsError,
    data: healthCardDetailsData,
  } = useQuery(GET_HEALTHCARD_DETAILS(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    variables: {
      policyId: data.id,
    },
  })

  const handleDocumentDownload = async (document, documentURL) => {
    documentDownload(document ? document : [], documentURL)
  }

  if (healthCardDetailsLoading)
    return (
      <div className='loadingContainer'>
        <CircularProgress />
      </div>
    )

  if (healthCardDetailsError)
    return (
      <>
        <GraphQlErrors error={healthCardDetailsError} routeValue={'back'} />
      </>
    )

  {
    /* ToDo: Need to update the condition to show or download the Policy Document (Task: 2738) */
  }
  const isIncludedInGroupList = () => {
    return GROUP_HEALTH_LIST?.includes(activePolicyInsuranceType)
  }

  const showHealthStats = () => {
    return HEALTH_STATS_INSURANCE_LIST?.includes(activePolicyInsuranceType)
  }

  const showHealthCards = () => {
    return HEALTH_INSURANCE_LIST?.includes(activePolicyInsuranceType)
  }

  return (
    <div className='policyDocumentParent'>
      <div className={classes.upcomingRenewalsWrapper}>
        <Card classes={{ root: classes.root }}>
          <CardContent classes={{ root: classes.contentRoot }}>
            <div className={classes.renewalsItemWrapper}>
              <div className={classes.renewalsContent}>
                <div>
                  {(isCEO || !isIncludedInGroupList()) && (
                    <div>
                      <p className={classes.policyDocumentHeading}>
                        Download Policy Document
                      </p>
                      <div className={classes.downloadPolicyDocumentContainer}>
                        <Tooltip
                          TransitionComponent={Zoom}
                          placement='bottom'
                          title={'Download Policy Document'}
                          arrow
                          className={classes.downloadTooltip}
                        >
                          <span
                            onClick={() =>
                              handleDocumentDownload(
                                data?.policyDocument,
                                data?.policyDocumentURL
                              )
                            }
                          >
                            <img
                              src={policyDocumentPic}
                              className={classes.icon}
                              alt={'valueAdded'}
                            />
                          </span>
                        </Tooltip>

                        <div className='middle'>
                          <div>
                            <button className='text'>
                              <span
                                className='cursor-pointer'
                                onClick={() =>
                                  handleDocumentDownload(
                                    data?.policyDocument,
                                    data?.policyDocumentURL
                                  )
                                }
                              >
                                <img src={policyDocumentDownloadPic} />
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {showHealthCards() && (
                    <div>
                      <p className={classes.healthcardHeading}>Health Card</p>
                      <div className='container'>
                        {healthCards?.length !== 0 &&
                        ((healthCards?.[0]?.healthCards &&
                          healthCards?.[0]?.healthCards?.length !== 0) ||
                          healthCards?.[0]?.healthCardURL) ? (
                          <>
                            <Tooltip
                              TransitionComponent={Zoom}
                              placement='bottom'
                              title={'Download Health Card'}
                              arrow
                            >
                              <span
                                onClick={() =>
                                  handleDocumentDownload(
                                    healthCards?.[0]?.healthCards,
                                    healthCards?.[0]?.healthCardURL
                                  )
                                }
                              >
                                <img
                                  src={healthCardImage}
                                  className={classes.healthCardImg}
                                  alt={'valueAdded'}
                                />
                              </span>
                            </Tooltip>
                            <div className='overlay'></div>
                            <div className='middle'>
                              <div className={classes.commonPadding}>
                                <button className='text'>
                                  <span className='cursor-pointer'>
                                    <img
                                      src={policyDocumentDownloadPic}
                                      onClick={() =>
                                        handleDocumentDownload(
                                          healthCards?.[0]?.healthCards,
                                          healthCards?.[0]?.healthCardURL
                                        )
                                      }
                                    />
                                  </span>
                                </button>
                              </div>
                            </div>
                          </>
                        ) : (
                          <p className={classes.healthCardAlternative}>
                            {!GROUP_HEALTH_LIST?.includes(
                              activePolicyInsuranceType
                            )
                              ? YET_TO_BE_UPLOAD
                              : PLEASE_GET_IN_TOUCH_WITH_HR}
                          </p>
                        )}
                      </div>
                      {isCEO && showHealthStats() ? (
                        <div className={classes.statsContainer}>
                          <span>
                            Total Employees :
                            {healthCardDetailsData?.getCorporateEmployeeCount
                              ?.totalEmployeeCount ?? '0'}
                          </span>
                          <span>
                            Employees with Health Card :
                            {healthCardDetailsData?.getCorporateEmployeeCount
                              ?.employeeWithHealthCardCount ?? '0'}
                          </span>
                          <span>
                            Employees without Health Card :
                            {healthCardDetailsData?.getCorporateEmployeeCount
                              ?.employeeWithoutHealthCardCount ?? '0'}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default AllDocuments

const useStyles = makeStyles({
  upcomingRenewalsWrapper: {
    marginTop: '0px',
  },
  root: {
    borderRadius: '10px',
  },
  renewalsItemWrapper: {
    // display: "flex",
    alignItems: 'center',
    // height: "240px",
    overflow: 'hidden',
  },
  contentRoot: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  legend: {
    maxWidth: '100vw',
    flexBasis: '150px',
    height: '50px',
    // marginTop: "-20px",
    background: COLORS.DARK_PINK,
    display: 'flex',

    alignItems: 'center',
  },
  commonPadding: {
    padding: '10px',
  },
  healthCardAlternative: {
    fontSize: '14px',
  },
  legendTitle: {
    fontSize: '17px',
    lineHeight: '24px',
    color: COLORS.WHITE,
    fontWeight: 600,
    textAlign: 'center',
    marginLeft: '15px',
  },
  renewalsContent: {
    width: '100%',
    flexGrow: 1,
    padding: '0px 0px 15px 0px',
  },
  renewalsItem: {
    borderBottom: `0.7px solid ${COLORS.GREY_11}`,
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    padding: '9px 10px',
    '&:last-child': {
      borderBottom: '0px solid',
    },
  },
  icon: {
    width: '175px',
    height: '175px',
    '&:hover': {
      opacity: '0.25',
    },
  },
  healthCardImg: {
    width: '175px',
    height: '175px',
    '&:hover': {
      opacity: '0.25',
    },
  },
  title: {
    fontSize: '13px',
    lineHeight: '18px',
    margin: '0 0 0 0',
    color: COLORS.GREY,
    flexBasis: '145px',
    flexShrink: 0,
  },
  healthcardHeading: {
    margin: '0px 0px',
    padding: '25px 15px 15px 15px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
  },
  policyDocumentHeading: {
    margin: '0px 0px',
    padding: '15px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
    fontSize: '18px',
    alignItems: 'center !important',
  },
  statsContainer: {
    fontSize: '14px',
    opacity: '0.6',
    display: 'flex',
    flexDirection: 'column',
  },
  downloadTooltip: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  downloadPolicyDocumentContainer: {
    margin: 'auto',
    opacity: 0.6,
    position: 'relative',
    cursor: 'pointer',
  },
})
